export const hideTimeoutWarning = "HIDE_TIMEOUT_WARNING";
export const setInactivityTime = "SET_INACTIVITY_TIME";
export const setSessionStartTime = "SET_SESSION_START_TIME";
export const showTimeoutWarning = "SHOW_TIMEOUT_WARNING";
export const setMinimizeWindow = "SET_MINIMIZE_WINDOW";


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/timeout-warning-overlay/src/actions/actionTypes.js